import axios from 'axios';
import * as apiConfig from '../../Config/apiConfig';
import {throwErrorClient, throwErrorServer} from '../../Util/errorUtil';
import {getAuth, resetAuth} from '../Actions/authAction';

const getClient = () => {
    return axios.create({
        baseURL: apiConfig.SERVER_URL,
        timeout: 30000
    });
};

const getAuthClient = (token: string, timeout?: number) => {
    return axios.create({
        baseURL: apiConfig.SERVER_URL,
        timeout: timeout || 30000,
        headers: {
            'Authorization': token
        }
    });
};

const onResponseSuccess = (response) => {
    return response;
};

const onResponseError = (error) => {
    if(error.response) {
        const data = error.response.data;
        if (error.response.status === 403) {
            resetAuth();
            throwErrorClient(351);
        }
        else if (typeof data.errors === 'undefined') {
            // Not custom error
            throwErrorServer(300, data.error);
        }
        else {
            data.errors.forEach((err) => {
                throwErrorServer(err.code, err.message);
            });
        }
    }
    else {
        // Server response missing, 500
        throwErrorClient(0);
    }
    return Promise.reject(error.response || error.message);
};

export const request = (options: any) => {
    return getClient()(options)
        .then(onResponseSuccess)
        .catch(onResponseError);
};

export const authRequest = (options: any, timeout?: number) => {
    return getAuthClient(getAuth().token, timeout || null)(options)
        .then(onResponseSuccess)
        .catch(onResponseError);
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/APIs/request.ts